export const getTranslatedName = (translations) => {
  const selectedLanguage = localStorage.getItem("locale_lang") || "en";
  if (!translations || !Array.isArray(translations) || !selectedLanguage) {
    return "";
  }

  // Find the translation that starts with the selected language code (e.g., "en", "tr", "ro", "cs", "nl", "fr", "es", "pt")
  let translation = translations?.find((item) =>
    item.language.startsWith(selectedLanguage + "-")
  );

  return translation ? translation.name : "";
};
